module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "body-copy"
  }, [_vm._v("Executive Book Editor: Elaine H. Brelsford")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "body-copy"
  }, [_vm._v("Copy Editor: Chrystal Abhalter")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "body-copy"
  }, [_vm._v("Graphic Design: Lynda Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "body-copy"
  }, [_vm._v("Cover Design: Michael Buckingham")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph1"
  }, [_c('span', {
    staticClass: "body-copy"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "body-copy1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "body-copy1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "body-copy1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "body-copy1"
  }, [_vm._v("Cover quilt: Bow Tie Quilt by Martha Dellasega Gray (2007). 62")]), _c('span', {
    staticClass: "body-copy1"
  }, [_vm._v("”")]), _c('span', {
    staticClass: "body-copy1"
  }, [_vm._v(" x 78")]), _c('span', {
    staticClass: "body-copy1"
  }, [_vm._v("”. ")]), _c('span', {
    staticClass: "body-copy1"
  }, [_vm._v("Hand pieced and hand quilted.")]), _c('span', {
    staticClass: "body-copy2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "100039.png",
      "src": "OEBPS/image/100039.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "85592.png",
      "src": "OEBPS/image/85592.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I’d like to dedicate this book to my incredible readership that continues to encourage me with compliments and personal experiences as they read my novels. It has made my journey a real pleasure! I will always be grateful. Thank you.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "normal"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "100075.png",
      "src": "OEBPS/image/100075.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0b614","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/everlastingquilts_split1.vue
// module id = 63
// module chunks = 0